import { buildCsvFromRows, escapeCsvCell } from '../../../../shared/csv-core/infra/buildCsv';
import { normalizeUnitOfMeasure, type UnitOfMeasure } from '@shared/quantity';
import type { StockMovementRow } from '../../domain/stockTypes';

/** Generación pura del CSV (sin React Native). */
export function buildStockMovementHistoryCsv(params: {
  productName: string;
  branchLabel: string;
  unitOfMeasure?: UnitOfMeasure | string | null;
  rows: StockMovementRow[];
  reasonLabel: (reason: string | null) => string;
  actorLabel: (userId: string | null | undefined) => string;
  formatMoney: (n: number | null) => string;
}): string {
  const { productName, branchLabel, unitOfMeasure, rows, reasonLabel, actorLabel, formatMoney } = params;
  const unitOfMeasureCell = normalizeUnitOfMeasure(unitOfMeasure);
  const header = [
    'fecha_iso',
    'motivo',
    'delta',
    'unidad_medida',
    'costo_unitario',
    'usuario_actor',
    'referencia',
    'id_movimiento',
    'producto',
    'sucursal',
  ];
  const dataLines = rows.map((m) => [
    escapeCsvCell(m.createdAt),
    escapeCsvCell(reasonLabel(m.reason)),
    String(m.delta),
    escapeCsvCell(unitOfMeasureCell),
    escapeCsvCell(formatMoney(m.unitCost)),
    escapeCsvCell(actorLabel(m.performedByUserId)),
    escapeCsvCell(m.referenceId ?? ''),
    escapeCsvCell(m.id),
    escapeCsvCell(productName),
    escapeCsvCell(branchLabel),
  ]);
  return buildCsvFromRows(header, dataLines);
}
